/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import { useEffect } from "react";
import axios from "../api/axiosInstance";

export const useReservationGroup = ({
  reservationIdRef,
  setGroupReservations,
  setSelectedReservationId,
  setFormData,
  setGroupData,
  setBookerData,
  setHasAnyDates,
  setCopyFromOptions,
  setCopyToOptions,
  location,
  reloadDatesFromDB,
  reloadAdultsFromDB,
  reloadChildrenFromDB,
  reloadRoomCategoryIdFromDB,
  reloadRoomIdFromDB,
  reloadRoomRateIdFromDB,
  reloadRoomCategoryDetailsFromDB,
  setDbDatesMap,
  setAdultsMap,
  setChildrenMap,
  setRoomCategoryMap,
  setRoomCategoryDetailsMap,
  setRoomIdMap,
  setRoomRateDetailsMap,
  searchParams,
  formData,
}) => {

  useEffect(() => {
    const id = reservationIdRef.current;
    if (!id) return;

    reloadDatesFromDB(id, setDbDatesMap);
    reloadAdultsFromDB(id, setAdultsMap);
    reloadChildrenFromDB(id, setChildrenMap);
    reloadRoomCategoryIdFromDB(id, setRoomCategoryMap);
    reloadRoomIdFromDB(id, setRoomIdMap);
    reloadRoomRateIdFromDB(id, setRoomRateDetailsMap);
    reloadRoomCategoryDetailsFromDB(id, setRoomCategoryDetailsMap);

  }, []);

console.log("🧨 EFFECT A fetchGroupAfterNavigation", reservationIdRef.current);
console.log("🧨 EFFECT B fetchGroupInfo", reservationIdRef.current);

  useEffect(() => {
    const reservationId = reservationIdRef.current;
    if (!reservationId) return;

    let cancelled = false;

    const loadGroupOnce = async () => {
      console.log("🟢 [GROUP] Initial load for reservation", reservationId);

      console.log("🌐 GET reservation-drafts", reservationId);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`
      );
      if (cancelled) return;

      const reservation = res.data;
      if (!reservation.reservation_group_id) return;

      // 🧱 Group core data (persistente)
      setGroupData({
        id: reservation.reservation_group_id,
        group_locator: reservation.group.group_locator,
        number_of_rooms: reservation.group.number_of_rooms,
      });

      setFormData((prev) => ({
        ...prev,
        reservation_group_id: reservation.reservation_group_id,
        group_locator: reservation.group.group_locator,
        group_total_rooms: reservation.group.number_of_rooms,
      }));

      // 🧩 Reservas del grupo
      console.log("🌐 GET group reservations", reservation.reservation_group_id);
      const groupRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/reservation-drafts/reservations/group/${reservation.reservation_group_id}`
      );
      if (cancelled) return;
      setGroupReservations(groupRes.data);

      // 🔑 SYNC ACTIVE RESERVATION ID (source of truth)
      setSelectedReservationId(reservation.id);
      reservationIdRef.current = reservation.id;

      console.log("[GROUP][SYNC] Active reservation set", {
        reservationId: reservation.id
      });

      // 👤 Booker
      if (reservation.group.booker_id) {
        const bookerRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/customers/${reservation.group.booker_id}`
        );
        if (!cancelled) setBookerData(bookerRes.data);
      }

      /*/ 🔁 Copy info
      console.log("🌐 GET copy-info-options", reservation.reservation_group_id);
      const copyRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/reservation-draft-groups/${reservation.reservation_group_id}/copy-info-options`
      );
      if (!cancelled) {
        setHasAnyDates(copyRes.data.has_any_dates);
        setCopyFromOptions(copyRes.data.copy_from_options);
        setCopyToOptions(copyRes.data.copy_to_options);
      }*/

      console.log("🟢 [GROUP] Loaded once and locked");
    };

    loadGroupOnce();

    return () => {
      cancelled = true;
    };
  }, []);



    



    /* Lógica antigua, cuando leía de la URL y no de la base de datos
    
      useEffect(() => {
        const guestType = searchParams.get("guest_type");
        const bookerId = searchParams.get("booker_id");
    
      
        if (guestType === "booker" && formData.reservation_group_id && bookerId) {
          console.log("📘 Ejecutando PATCH para asignar booker desde SelectCustomer");
        
          axios
            .patch(`${process.env.REACT_APP_API_URL}/api/reservation-groups/${formData.reservation_group_id}`, {
              booker_id: Number(bookerId),
            })
            .then(() => {
              console.log("✅ booker_id asignado correctamente desde useEffect");
        
              // 👇 Aquí recargamos y marcamos como manual
              axios
                .get(`${process.env.REACT_APP_API_URL}/api/customers/${bookerId}`)
                .then((res) => {
                  const flagged = { ...res.data, __manual_insert: true };
                  setBookerData(flagged);
                  
                })
                .catch((err) => console.warn("⚠️ No se pudo cargar booker tras asignarlo:", err));
            })
        
            .catch((err) => {
              console.error("❌ Error asignando booker desde useEffect:", err);
            });
        }
      }, [searchParams, formData.reservation_group_id]);
      */
    

};
